const PRAISE_WALL_ILLEGAL_TOKEN = () => (
    <div>
        <h1>Incorrect Praise Wall Link</h1>
        <p>
            The link to your Praise Wall is incorrect. <br />
            Please make sure the feature is enabled in your Small Improvements account. You can return to the Praise
            Wall settings page to copy the link again. <br />
            If this still doesn't work, please contact support.
        </p>
    </div>
);

export default {
    PRAISE_WALL_ILLEGAL_TOKEN,
};
